export default __webpack_public_path__ + "_/images/cocktail/cocktail-background-a30a129c50a470a8d3893b797c8cbc1171638e038aa4fd876450ed242d0a062f.png";